import { IsString } from 'class-validator';
import { BaseStatusDto } from './baseStatusDto';
export class ApplicationSourceDto extends BaseStatusDto {

    @IsString()
    logoURL: string;
}
